import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

// Styled Components
const FooterWrapper = styled.footer`
  background: linear-gradient(135deg, #0b0b0b, #222);
  color: #fff;
  padding: 2rem 1.5rem; /* Reduced padding */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem; /* Reduced gap */
  font-size: 0.8rem; /* Slightly smaller font size */
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.7);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    top: 0;
    background: linear-gradient(90deg, #5b89bd, #2a3f90, #63a3ac, #e5ecf2, #6cb3a5);
    animation: moveLine 5s linear infinite;
  }

  @keyframes moveLine {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1rem; /* Less padding for mobile */
    gap: 1rem; /* Less gap for mobile */
    font-size: 0.75rem; /* Smaller font size */
  }
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  text-decoration: none;
  transition: transform 0.3s, filter 0.3s;
  filter: drop-shadow(0px 0px 12px rgba(255, 255, 255, 0.3));

  &:hover {
    transform: scale(1.1);
    filter: drop-shadow(0px 0px 18px rgba(255, 255, 255, 0.5));
  }

  @media (max-width: 768px) {
    gap: 0.5rem; /* Smaller gap for mobile */
  }
`;

const LogoImage = styled.img`
  height: 50px; /* Slightly reduced size */
`;

const LogoText = styled.span`
  font-size: 1.6rem; /* Slightly smaller font size */
  font-weight: bold;
  color: #fff;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1.4rem; /* Smaller font size for mobile */
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem; /* Reduced gap */
  flex-wrap: wrap;
  justify-content: center;

  a {
    color: #ddd;
    text-decoration: none;
    font-weight: 600;
    position: relative;
    transition: color 0.3s, transform 0.3s;
    font-size: 0.9rem; /* Slightly smaller font size */
  }

  a::after {
    content: "";
    display: block;
    height: 3px;
    width: 0;
    background: #f39c12;
    transition: width 0.3s;
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
  }

  a:hover {
    color: #f39c12;
    transform: translateY(-3px);
  }

  a:hover::after {
    width: 100%;
  }

  @media (max-width: 768px) {
    gap: 1rem; /* Less gap for mobile */
  }
`;

const ContactInfo = styled.div`
  font-size: 0.75rem; /* Slightly smaller font size */
  opacity: 0.9;
  text-align: center;
  line-height: 1.4; /* Reduced line height */

  p {
    transition: transform 0.3s;
  }

  p:hover {
    transform: scale(1.05);
    color: #f39c12;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem; /* Smaller font size for mobile */
  }
`;

const FooterBottom = styled.div`
  font-size: 0.7rem; /* Slightly smaller font size */
  opacity: 0.7;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 0.8rem; /* Reduced padding */
  width: 100%;
  text-align: center;
  transition: opacity 0.3s;

  &:hover {
    opacity: 1;
    color: #f39c12;
  }

  @media (max-width: 768px) {
    font-size: 0.65rem; /* Smaller font size for mobile */
  }
`;

// Footer Component
const Footer = () => {
  return (
    <FooterWrapper>
      <LogoContainer to="/">
        <LogoImage src={logo} alt="Logo" />
        <LogoText>DocGenesys</LogoText>
      </LogoContainer>
      <FooterLinks>
        <Link to="/about">About Us</Link>
        <Link to="/services">Services</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-service">Terms of Service</Link>
      </FooterLinks>
      <ContactInfo>
        <p>Email: csa_india@csatechlabs.com</p>
        <p>Phone: +123 456 7890</p>
        <p>Address: E-44/3, 1st Floor, Okhla Industrial Area, Phase-2, New Delhi, 110020, India</p>
      </ContactInfo>
      <FooterBottom>
        <p>&copy; 2025 CSA Tech Labs. All rights reserved.</p>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;
